import { Endpoint } from '@business/api/endpoint';
import { PayablesInvoiceItemSearchParams, TMProviderInvoiceId, TMProviderInvoiceItemResponse } from '@business/entities/tm/TMProviderInvoiceResponse';
import { R } from '@core/utils/r';
import { ProviderInvoiceFormData } from '@modules/timeMaterials/TimeMaterialOverlay/ProviderInvoiceModal/ProviderInvoiceModal';
import { TMInvoiceScheduleFormData } from '@modules/timeMaterials/TimeMaterialOverlay/Tabs/Order/AddEditTMInvoiceScheduleModal/AddEditTMInvoiceScheduleModal';

export function fetchInvoiceItems(data?: PayablesInvoiceItemSearchParams) {
  const params = R.objectCompact(data);
  return Endpoint.get<TMProviderInvoiceItemResponse[]>(`@gc/provider-invoice-item`, { params });
}

export function createInvoiceItem(data: TMInvoiceScheduleFormData) {
  return Endpoint.post<TMProviderInvoiceItemResponse>(`@gc/provider-invoice-item`, { data });
}

export function createInvoiceItems(data: ProviderInvoiceFormData) {
  return Endpoint.post<TMProviderInvoiceItemResponse[]>(`@gc/provider-invoice-item/invoices`, { data });
}

export function updateInvoiceItem(id: TMProviderInvoiceId, data: TMInvoiceScheduleFormData) {
  return Endpoint.patch<TMProviderInvoiceItemResponse>(`@gc/provider-invoice-item/${id}`, { data });
}

export function deleteInvoiceItem(id: TMProviderInvoiceId) {
  return Endpoint.delete<void>(`@gc/provider-invoice-item/${id}`);
}

export function fetchInvoiceItem(id: TMProviderInvoiceId) {
  return Endpoint.get<TMProviderInvoiceItemResponse>(`@gc/provider-invoice-item/invoice/${id}`);
}
